import Marquee from "react-fast-marquee";
import { Flame } from "lucide-react";

const SPONSOR_LOGOS = [
  { name: "EM Invest", src: "/logos/em-invest.webp" },
  { name: "ISS", src: "/logos/iss.webp" },
  { name: "Kühlwein Restaurants", src: "/logos/kuehlwein.webp" },
  { name: "Latschenwirt", src: "/logos/latschenwirt.webp" },
  { name: "Reform", src: "/logos/reform.webp" },
  { name: "Shark Ninja", src: "/logos/shark-ninja.webp" },
  { name: "VISA", src: "/logos/visa.webp" },
  { name: "AEROX", src: "/logos/aerox.webp" },
  { name: "Bauchinger", src: "/logos/bauchinger.webp" },
  { name: "Gerüstbau Eichriedler", src: "/logos/eichriedler.webp" },
  { name: "Hermann Heim", src: "/logos/hermann-heim.webp" },
  { name: "Moser Bautrocknung", src: "/logos/moser-bautrocknung.webp" },
  { name: "PRC", src: "/logos/prc.webp" },
  { name: "Pure", src: "/logos/pure.webp" },
  { name: "Tradler Baumaschinen", src: "/logos/tradler.webp" },
  { name: "Smile Clinic", src: "/logos/smile-clinic.webp" },
  { name: "Hinterreiter Krampusse", src: "/logos/hinterreiter.webp" },
  { name: "Essen in Salzburg", src: "/logos/essen-in-salzburg.webp" },
  { name: "inspiranto", src: "/logos/inspiranto.webp" },
  { name: "SKY", src: "/logos/sky.webp" },
  { name: "Weekend", src: "/logos/weekend.webp" },
  { name: "Format Orange", src: "/logos/format-orange.webp" },
  { name: "FreshFX", src: "/logos/freshfx.webp" },
  { name: "Früchte-Express", src: "/logos/fruechte-express.webp" },
  { name: "Großgmainer Krampusse", src: "/logos/grossgmainer-krampusse.webp" },
  { name: "Harl Team", src: "/logos/harl-team.webp" },
];

export default function SponsorsMarquee() {
  return (
    <div data-testid="sponsors-marquee" className="border-y border-white/10 bg-hell-black py-8 md:py-10 overflow-hidden">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {SPONSOR_LOGOS.map((s) => (
          <span key={s.name} className="flex items-center gap-12 md:gap-16 pr-12 md:pr-16">
            <img
              src={s.src}
              alt={s.name}
              loading="lazy"
              data-testid={`sponsor-logo-${s.name.toLowerCase().replace(/\s/g, "-")}`}
              className="h-12 md:h-16 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity duration-500"
            />
            <Flame className="w-4 h-4 text-hell-ember/60 shrink-0" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
